import * as React from "react";
import { UitkTypeahead, ESSAdapter } from "uitk-react-typeahead";
import { LocationFieldProps } from "./typings";

export const LocationField: React.FunctionComponent<LocationFieldProps> = ({
  essAdapterConfig,
  isDest,
  context,
  onClick,
  onDismiss,
  onUpdate,
  renderDialog,
  icon,
  name,
  label,
  typeaheadPlaceholder,
  invalid,
  value,
  stid,
  config,
  location,
}) => {
  const regionIdParam = config.queryParams && config.queryParams.regionId ? config.queryParams.regionId : "";
  const iataCodeParam = config.queryParams && config.queryParams.iataCode ? config.queryParams.iataCode : "";
  const latLongParam = config.queryParams && config.queryParams.latLong ? config.queryParams.latLong : "";
  const countryCodeParam = config.queryParams && config.queryParams.countryCode ? config.queryParams.countryCode : "";

  let essAdapterFeatures = essAdapterConfig.features;
  if (essAdapterFeatures.indexOf("consistent_display") < 0) {
    essAdapterFeatures += "|consistent_display";
  }

  return (
    <div>
      <UitkTypeahead
        adapter={
          new ESSAdapter({
            client: essAdapterConfig.client,
            dest: isDest,
            features: essAdapterFeatures,
            guid: context.guid,
            inputId: stid,
            lob: essAdapterConfig.lob,
            locale: context.locale,
            maxResults: essAdapterConfig.maxResults,
            regionType: essAdapterConfig.regionType,
            siteId: context.site.id,
          })
        }
        onClick={onClick}
        onDismiss={onDismiss}
        onUpdate={onUpdate}
        renderDialog={renderDialog}
        hasClearButton={false}
        allowExactMatch={true}
        icon={icon}
        name={name}
        label={label}
        invalid={invalid}
        value={value}
        stid={stid}
        typeaheadPlaceholder={typeaheadPlaceholder}
      />
      {regionIdParam && location.metaData.regionId && (
        <input type="hidden" name={regionIdParam} value={location.metaData.regionId} />
      )}
      {iataCodeParam && location.metaData.ttla && (
        <input type="hidden" name={iataCodeParam} value={location.metaData.ttla} />
      )}
      {latLongParam && location.metaData.latLong && (
        <input type="hidden" name={latLongParam} value={location.metaData.latLong} />
      )}
      {countryCodeParam && location.metaData.countryCode && (
        <input type="hidden" name={countryCodeParam} value={location.metaData.countryCode} />
      )}
    </div>
  );
};
